import type { PageRequest } from '@atlassian/jira-shared-types/src/rest/jira/page.tsx';
import type { Filter } from '../../../model/index.tsx';
import get from '../../../rest/boards/get/index.tsx';
import type { Response as RestResponse } from '../../../rest/boards/get/types.tsx';
import { transformBoards } from './transformers.tsx';
import type { Response as ResponseType } from './types.tsx';

// eslint-disable-next-line jira/export/restrict-types-re-export
export type Response = ResponseType;

const getBoards = async (request: PageRequest, filter: Filter): Promise<Response> => {
	const restResponse: RestResponse = await get(request, filter, true);
	return transformBoards(restResponse.values, restResponse.total);
};

export default getBoards;
